import React, { useState, useRef } from "react";
import withPortal from "jd-library/withPortal";
import Modal from "jd-library/Modal";
import "./commission-modal.scss";
import { getImagePath } from "../../common/productImageUtils";
import historyHandler from "jd-library/historyHandler";

const CommissionModal = (props) => {
  const [scrolled, setScroll] = useState(false);
  const scrollRef = useRef(null);

  const productName = props.data?.productName;
  const sellingPriceVal = parseFloat(props.data?.sp).toFixed(2);
  const gstVal = (parseFloat(props.data?.order?.tax) + parseFloat(props.data?.order?.tds)).toFixed(2);
	let gstRateText = props.data?.invoice?.tax_rate && parseFloat(props.data.invoice.tax_rate) % 1 != 0 ? parseFloat(props.data.invoice.tax_rate).toFixed(2) : parseInt(props.data.invoice.tax_rate);
  const grossAmountVal = parseFloat(props.data?.net_taxable_value).toFixed(2);
  const tcsVal = props.data?.order?.tcs ? props.data?.order?.tcs : 0;
  const tdsVal = props.data?.order?.tds ? props.data?.order?.tds : 0;
  const fixedFeeVal = (parseFloat(props.data?.mktplace_fees?.fixed?.commission) + parseFloat(props.data?.mktplace_fees?.fixed?.tax)).toFixed(2) ? (parseFloat(props.data?.mktplace_fees?.fixed?.commission) + parseFloat(props.data?.mktplace_fees?.fixed?.tax)).toFixed(2) : 0;
  const fixedFeeText = props.data?.mktplace_fees?.fixed?.text;
  const shippingFeeVal = (parseFloat(props.data?.mktplace_fees?.logistic?.commission) + parseFloat(props.data?.mktplace_fees?.logistic?.tax)).toFixed(2);
  const shippingFeeText = props.data?.mktplace_fees?.logistic?.text;
  const commissionFeeVal = (parseFloat(props.data?.mktplace_fees?.JDcommission?.commission) + parseFloat(props.data?.mktplace_fees?.JDcommission?.tax)).toFixed(2);
  const commissionFeeText = props.data?.mktplace_fees?.JDcommission?.commission_rate && parseFloat(props.data.mktplace_fees.JDcommission.commission_rate) % 1 != 0 ? parseFloat(props.data.mktplace_fees.JDcommission.commission_rate).toFixed(2) : parseInt(props.data.mktplace_fees.JDcommission.commission_rate);
  const youPayVal = props.data?.final_payout?.toFixed(2);

  const handleScroll = () => {
    const isScrolled = scrollRef.current.scrollTop > 10;
    if (isScrolled !== scrolled) {
      setScroll(isScrolled);
    }
  };

  const getImageUrl = () => {
    let imageUrlString = props.data.imageUrl;
    let getFirstImage = imageUrlString.split(",")[0];
    console.log("getImagePath(getFirstImage)",getImagePath(getFirstImage));
    return getImagePath(getFirstImage);
  }

  return (
    <div>
      <Modal
        settings={{
          modalId: "center-btn",
          class: "comission-modal",
          variant: "action",
        }}
        onHidden={() => {
          props.onHidden();
        }}
      >
        <Modal.CloseIcon />
        <Modal.Header
          className={`heading-txt ${scrolled ? "commission-modl-shadow" : ""}`}
        >
          Commission Details
        </Modal.Header>
        <Modal.Body className="comission-body-holder">
          <div
            className="comission-body-container"
            ref={scrollRef}
            onScroll={handleScroll}
          >
                <div className="product-gist">
                    <div className="product-image-holder">
                        <img className="product-image" src={getImageUrl()} alt="" />
                    </div>
                    <p class="product-desc">{productName}</p>
                </div>
                <div className="item-detail">
                    <p className="item-detail-property-bold">Your Selling Price <span className="item-detail-other-info">Incl. of GST</span></p>
                    <p className="item-detail-value-black">₹ {sellingPriceVal}</p>
                </div>
                <div className="item-detail">
                    <p className="item-detail-property-regular">GST <span className="item-detail-other-info">@ {!props.data.invoice.tax_rate ? 0 : gstRateText}%</span></p>
                    <p className="item-detail-value-red">- ₹ {gstVal}</p>
                </div>
                <div class="dashed-seperator"></div>
                <div className="item-detail">
                    <p className="item-detail-property-bold">Gross Amount <span className="item-detail-other-info">Excl. of GST</span></p>
                    <p className="item-detail-value-black">₹ {grossAmountVal}</p>
                </div>
                <div className="item-detail">
                    <p className="item-detail-property-regular">TCS <span className="item-detail-other-info">@ 1% of Gross Amnt.</span></p>
                    <p className="item-detail-value-red">- ₹ {tcsVal}</p>
                </div>
                <div className="item-detail">
                    <p className="item-detail-property-regular">TDS <span className="item-detail-other-info">@ 1% of Gross Amnt.</span></p>
                    <p className="item-detail-value-red">- ₹ {tdsVal}</p>
                </div>
                <div className="item-detail">
                    <p className="item-detail-property-regular">Fixed Fee <span className="item-detail-other-info">{fixedFeeText}</span></p>
                    <p className="item-detail-value-red">- ₹ {fixedFeeVal}</p>
                </div>
                <div className="item-detail">
                    <p className="item-detail-property-regular">Shipping Fee <span className="item-detail-other-info">{shippingFeeText}</span></p>
                    <p className="item-detail-value-red">- ₹ {shippingFeeVal}</p>
                </div>
                <div class="dashed-seperator"></div>
                <div className="item-detail">
                    <p className="item-detail-property-bold">Comission Fee <span className="item-detail-other-info">{`@ ${!props.data.mktplace_fees.JDcommission.commission_rate ? 0 : commissionFeeText}% of Gross Amnt. + GST`}</span></p>
                    <p className="item-detail-value-red-bold">- ₹ {commissionFeeVal}</p>
                </div>
                <div class="solid-seperator"></div>
                <div className="item-detail">
                    <p className="item-detail-property-bold">How much you get <span className="item-detail-other-info"></span></p>
                    <p className="item-detail-value-black">₹ {youPayVal}</p>
                </div>
                <p className="item-detail-breakup-keys">Selling Price - TCS - TDS - Fixed Fee - Shipping Fee - Commission Fee</p>
          </div>
        </Modal.Body>
        <Modal.CenterButton
          className="fs-sb"
          variant="primary"
          showLoader ={props.showBtnLoader}
          onClick={() => {
            historyHandler.closeCurrent();
            props.onHidden();
          }}
        >
          Ok, Got It
        </Modal.CenterButton>
      </Modal>
    </div>
  );
};
export default withPortal(CommissionModal);
